module.exports = new __parcel__URL__("Alameda-South-Shore-Beach.a682d7f2.webp").toString();